import axios from "axios";

import request from "./request.js";

//post请求接口
export const Post = (url, params) => {
  return new Promise((resolve, reject) => {
    request({
      method: "post",
      url: url,
      data: params || {},
      // headers: {
      //   "Content-Type": "application/json"
      // }
    })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const Get = (url, params) => {
  return new Promise((resolve, reject) => {
    request({
      method: "get",
      url: url,
      data: params || {},
      // headers: {
      //   "Content-Type": "application/json"
      // }
    })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const login = (params) => {
  return Post(`/api/login`, params);
};
export const send_code = (params) => {
  return Post(`/common/sms_send`, params);
};
export const getUserInfo = (params) => {
  return Post(`/api/find`, params);
};
export const upload_pdf = (params) => {
  return Post(`/common/2022/upload_pdf`, params);
};
export const log_out = (params) => {
  return Post(`/api/log_out`, params);
};
export const update_data = (params) => {
  return Post(`/api/update_data`, params);
};
export const index_class = (params) => {
  return Post(`/api/index_class`, params);
};
export const delete_class = (params) => {
  return Post(`/api/delete_class`, params);
};
export const add_class = (params) => {
  return Post(`/api/add_class`, params);
};
export const update_class = (params) => {
  return Post(`/api/update_class`, params);
};
export const user_list = (params) => {
  return Post(`/api/user_list`, params);
};
export const update_user_data = (params) => {
  return Post(`/api/update_user_data`, params);
};
export const delete_user = (params) => {
  return Post(`/api/delete_user`, params);
};
export const upload_file = (params) => {
  return Post(`/common/review_file_upload`, params, {
    cache: false,
    contentType: false,
    processData: false,
  });
};
export const user_list_export = (params) => {
  return Post(`/api/user_list_export`, params);
};
export const download_pdf = (params) => {
  return Post(`/api/download_pdf`, params);
};
// export const split_list = (params) => {
//   return Post(`/common/user_review_list`, params);
// };
// export const create_review = (params) => {
//   return Post(`/review/create_review`, params);
// };
// export const forget = (params) => {
//   return Post(`/review/forget`, params);
// };
// export const review_find = (params) => {
//   return Post(`/common/review_find`, params);
// };
// export const review_file = (params) => {
//   return Post(`/review/review_file`, params);
// };
// export const review_find_2 = (params) => {
//   return Post(`/review/review_find`, params);
// };
// export const user_review_list_all = (params) => {
//   return Post(`/review/user_review_list_all`, params);
// };

// export const bank_account_confirmation = (params) => {
//   return Post(`/review/bank_account_confirmation`, params);
// };

// export const create_review_innovation = (params) => {
//   return Post(`/review/create_review_innovation`, params);
// };
// export const create_review_rest = (params) => {
//   return Post(`/review/create_review_rest`, params);
// };
// export const user_child_detailst = (params) => {
//   return Post(`/common/user_child_details`, params);
// };
// export const review_state = (params) => {
//   return Post(`/review/review_state`, params);
// };

// export const user_review_list = (params) => {
//   return Post(`/review/user_review_list`, params);
// };
// export const summary_pdf = (params) => {
//   return Post(`/review/summary_pdf`, params);
// };
// export const upload_file = (params) => {
//   return Post(`/common/review_file_upload`, params, {
//     cache: false,
//     contentType: false,
//     processData: false,
//   });
// };
